import { createFileRoute } from '@tanstack/react-router'

import type { TAssignmentSearch, TCardStatusSearch } from '#pages/AnonymousCards/shared/interfaces'
import { mapLegacySharedCardSearch } from '#pages/AnonymousCards/shared/legacySearch'

interface IAnonymousCardsSearch {
  search?: string
  sortBy?: string
  sortDir?: 'asc' | 'desc'
  cardStatus?: TCardStatusSearch
  assignment?: TAssignmentSearch
}

export const Route = createFileRoute('/_authenticated/companies_/$companyId/anonymous-cards')({
  validateSearch: (search: Record<string, unknown>): IAnonymousCardsSearch => {
    const mapped = mapLegacySharedCardSearch(search, 'assignment')

    return {
      search: typeof search.search === 'string' ? search.search : undefined,
      sortBy: typeof search.sortBy === 'string' && search.sortBy.length > 0 ? search.sortBy : undefined,
      sortDir: search.sortDir === 'asc' || search.sortDir === 'desc' ? search.sortDir : undefined,
      // Always present, including undefined. TanStack Router merges this result
      // over the raw search, so an omitted key would keep an unknown value.
      cardStatus: mapped.cardStatus,
      assignment: mapped.shareStatus,
    }
  },
})
